import { useEffect } from "react";

const DigilockerCallback = () => {
  useEffect(() => {
    // Post to parent window
    console.log({ window }, window.opener);

    if (window.opener) {
      window.opener.postMessage("digilocker_complete", window.location.origin);
    }
  }, []);

  return (
    <div className="container p-5 text-center">
      <h2 level={4}>Finalizing Aadhaar Verification…</h2>
      <p>You may close this tab manually if it doesn't close automatically.</p>
    </div>
  );
};

export default DigilockerCallback;
